// This module runs at import time (before React mounts) to preload hero images ASAP.
// It reads the current pathname and injects <link rel="preload"> into <head> immediately.

import heroWarehouse from "@/assets/hero-warehouse-opt.webp";
import heroDiensten from "@/assets/hero-diensten-opt.webp";
import heroWaarom from "@/assets/hero-waarom-opt.webp";
import heroContact from "@/assets/hero-contact-opt.webp";
import heroBlog from "@/assets/hero-blog-opt.webp";

const heroMap: Record<string, string> = {
  "/": heroWarehouse,
  "/diensten": heroDiensten,
  "/waarom-taverne": heroWaarom,
  "/contact": heroContact,
  "/blog": heroBlog,
};

// Execute immediately on module load
const path = window.location.pathname;

// Preload current page hero with highest priority
const currentHero = heroMap[path] || heroMap["/"];
if (currentHero) {
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "image";
  link.href = currentHero;
  link.setAttribute("fetchpriority", "high");
  document.head.appendChild(link);
}

// Prefetch adjacent heroes with low priority
Object.entries(heroMap).forEach(([route, src]) => {
  if (route !== path) {
    const link = document.createElement("link");
    link.rel = "prefetch";
    link.as = "image";
    link.href = src;
    document.head.appendChild(link);
  }
});
